import React from 'react'
import { size, map } from 'lodash'
import { connect } from 'react-redux'
import { Header, Button, Icon, Card, Divider, Loader } from 'semantic-ui-react'

import QuantityCard from './Card'
import QuantityForm from './Form'

import RestaurantActions from '../../../../reducers/restaurantReducer'
import QuantityPromotionActions from '../../../../reducers/quantityPromotionReducer'

const styles = {
  header: {
    float: 'left',
    marginBottom: 0,
  },
  conatiner: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    padding: '0px 14px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}

class QuantityPromotions extends React.PureComponent {
  state = {
    action: '',
    promotion: null,
    formVisible: false,
  }

  componentDidMount() {
    const { restaurantLoaded, fetchRestaurants, quantityPromotionLoaded, getQuantityPromotions } = this.props;

    if (!restaurantLoaded) fetchRestaurants()

    if (!quantityPromotionLoaded) getQuantityPromotions()
  }

  onDelete = (promotion) => {
    const { deletePromotion } = this.props

    const prompt = window.confirm(`Are you sure to delete ${promotion.title} promotion?`)

    if (prompt) {
      return deletePromotion(promotion)
    }

    return false
  }

  onEdit = promotion => this.setState({ promotion, action: 'edit', formVisible: true })

  renderPromotionCards = () => {
    const { quantityPromotions } = this.props

    if (size(quantityPromotions) === 0) {
      return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>
    }

    return (
      <Card.Group style={{ margin: 0 }}>
        {map(quantityPromotions, (promotion, key) => (
          <QuantityCard
            key={key}
            promotion={promotion}
            onEdit={() => this.onEdit(promotion)}
            onDelete={() => this.onDelete(promotion)}
          />
        ))}
      </Card.Group>
    )
  }

  render() {
    const { formVisible, action, promotion } = this.state
    const { restaurants, authData, restaurantLoaded, quantityPromotionLoaded, quantityPromotions, savePromotion } = this.props

    if (!quantityPromotionLoaded || !restaurantLoaded) {
      return (
        <React.Fragment>
          <Loader active />
        </React.Fragment>
      )
    }

    return (
      <div style={styles.conatiner}>
        <div style={styles.headerWrapper}>
          <Header style={styles.header}>{`Quantity Promotions (${size(quantityPromotions)})`}</Header>
          <Button icon color="black" style={{ float: 'right' }} onClick={() => this.setState({ formVisible: true, action: 'new' })}>
            <Icon name="add" /> Add New
          </Button>
        </div>

        <Divider style={{ margin: 14 }} />

        <div style={{ overflow: 'auto' }}>{this.renderPromotionCards()}</div>

        {formVisible && (
          <QuantityForm
            action={action}
            authData={authData}
            promotion={promotion}
            restaurants={restaurants}
            savePromotion={savePromotion}
            quantityPromotions={quantityPromotions}
            onClose={() =>
              this.setState({ formVisible: false, action: '', promotion: null })
            }
          />
        )}
      </div>
    )
  }
}

const mapState = ({ auth, restaurants, quantityPromotions }) => ({
  authData: auth.data,
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,

  quantityPromotions: quantityPromotions.data,
  quantityPromotionLoaded: quantityPromotions.loaded,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getQuantityPromotions: QuantityPromotionActions.getQuantityPromotions,

  savePromotion: QuantityPromotionActions.saveQuantityPromotion,
  deletePromotion: QuantityPromotionActions.deleteQuantityPromotion,
}

export default connect(mapState, mapDispatch)(QuantityPromotions)


// WEBPACK FOOTER //
// ./src/containers/promotions/components/QuantityPromotions/index.js